var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94336 5.75C7.35757 5.75 7.69336 6.08579 7.69336 6.5V8.75H9.94336C10.3576 8.75 10.6934 9.08579 10.6934 9.5C10.6934 9.91421 10.3576 10.25 9.94336 10.25H6.19336V6.5C6.19336 6.08579 6.52915 5.75001 6.94336 5.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.5C9.97288 3.5 12.4388 5.66245 12.915 8.5H21C22.1046 8.5 23 9.39543 23 10.5V18.5L22.9893 18.7041C22.8938 19.6457 22.1457 20.3938 21.2041 20.4893L21 20.5H7L6.7959 20.4893C5.85435 20.3938 5.1062 19.6457 5.01074 18.7041L5 18.5V15.1572C2.66984 14.3334 1 12.1123 1 9.5C1 6.18629 3.68629 3.5 7 3.5ZM14 17.2139L10.1797 14.5869C9.2576 15.1645 8.16829 15.5 7 15.5V18.5H21V12.4004L14 17.2139ZM12.915 10.5C12.745 11.513 12.321 12.4387 11.7109 13.2119L14 14.7861L20.2344 10.5H12.915ZM7 5C4.51472 5 2.5 7.01472 2.5 9.5C2.5 11.9853 4.51472 14 7 14C9.48528 14 11.5 11.9853 11.5 9.5C11.5 7.01472 9.48528 5 7 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleEmail);
export default __webpack_public_path__ + "static/media/Schedule_Email.33687947eff3332de8c1a205371fa5fb.svg";
export { ForwardRef as ReactComponent };